import kinetikApi from './kinetikAPI';

export default {
  createLOS: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/level-of-service`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteLos: (orgResourceId, uuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/level-of-service/ls/${uuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getVehicleCategories: (orgResourceId) =>
    kinetikApi
      .get(`/${orgResourceId}/config/level-of-service/vehicle-categories`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  createCustomFields: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/custom-fields`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getLOS: (orgResourceId, options = {}) =>
    kinetikApi
      .get(`/${orgResourceId}/config/level-of-service`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  updateLOS: (orgResourceId, levelOfServiceUuid, body) =>
    kinetikApi
      .patch(
        `/${orgResourceId}/config/level-of-service/ls/${levelOfServiceUuid}`,
        body,
        { serviceName: 'config' },
      )
      .then((res) => res.data),
  getCustomFields: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/custom-fields`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  patchCustomField: (orgResourceId, fieldUuid, body) =>
    kinetikApi
      .patch(`/${orgResourceId}/config/custom-fields/cf/${fieldUuid}`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getLocationModifiers: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/location-modifiers`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  createLocationModifiers: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/location-modifiers`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteLocationModifiers: (orgResourceId, locationModifierUuid, body) =>
    kinetikApi
      .delete(
        `/${orgResourceId}/config/location-modifiers/lm/${locationModifierUuid}`,
        { ...body, serviceName: 'config' },
      )
      .then((res) => res.data),
  deleteCustomField: (orgResourceId, customFieldUuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/custom-fields/cf/${customFieldUuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getRestrictions: (orgResourceId) =>
    kinetikApi
      .get(`/${orgResourceId}/config/trip-restrictions`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  updateRestrictions: (orgResourceId, body) =>
    kinetikApi
      .patch(`/${orgResourceId}/config/trip-restrictions`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getAppointmentReasons: (orgResourceId, options = null) =>
    kinetikApi
      .get(`/${orgResourceId}/config/appointment-reasons`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  createAppointmentReasons: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/appointment-reasons`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteAppointmentReasons: (orgResourceId, uuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/appointment-reasons/ar/${uuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getMemberPreferences: (orgID) =>
    kinetikApi
      .get(`/${orgID}/config/patient-preferences`, { serviceName: 'config' })
      .then((res) => res.data),
  updateMemberPreferences: (orgID, body) =>
    kinetikApi
      .patch(`/${orgID}/config/patient-preferences`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getMileageReimbursementPreferences: (orgID) =>
    kinetikApi
      .get(`/${orgID}/config/mileage-reimbursement`, { serviceName: 'config' })
      .then((res) => res.data),
  updateMileageReimbursementPreferences: (orgID, body) =>
    kinetikApi
      .patch(`/${orgID}/config/mileage-reimbursement`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getRegionDatasets: (orgResourceId, datasetType, options = null) =>
    kinetikApi
      .get(`/${orgResourceId}/config/datasets/${datasetType}`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  createTripCancellationReasons: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/trip-cancellation`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getTripCancellationReasons: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/trip-cancellation`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteTripCancellationReason: (orgResourceId, uuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/trip-cancellation/tc/${uuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getAssignmentPreferences: (orgID) =>
    kinetikApi
      .get(`/${orgID}/config/assignment-preferences`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  updateAssignmentPreferences: (orgID, body) =>
    kinetikApi
      .patch(`/${orgID}/config/assignment-preferences`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getTripPreferences: (orgID) =>
    kinetikApi
      .get(`/${orgID}/config/trip-preferences`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  updateTripPreferences: (orgID, body) =>
    kinetikApi
      .patch(`/${orgID}/config/trip-preferences`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  createTripDenialReasons: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/trip-denial`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getTripDenialReasons: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/trip-denial`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteTripDenialReason: (orgResourceId, uuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/trip-denial/td/${uuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  createTripRejectionReasons: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/trip-rejection`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getTripRejectionReasons: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/trip-rejection`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteTripRejectionReason: (orgResourceId, uuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/trip-rejection/tr/${uuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getProCredExConnection: (orgResourceId, options) =>
    kinetikApi
      .get(`${orgResourceId}/config/job-registry`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  createTripEscalationReasons: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/trip-approval-request-reason`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getTripEscalationReasons: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/trip-approval-request-reason`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteTripEscalationReason: (orgResourceId, uuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/trip-approval-request-reason/${uuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  createTripApprovalReasons: (orgResourceId, body) =>
    kinetikApi
      .post(
        `/${orgResourceId}/config/trip-approval-request-approval-reason`,
        body,
        { serviceName: 'config' },
      )
      .then((res) => res.data),
  getTripApprovalReasons: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/trip-approval-request-approval-reason`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  deleteTripApprovalReason: (orgResourceId, uuid) =>
    kinetikApi
      .delete(
        `/${orgResourceId}/config/trip-approval-request-approval-reason/${uuid}`,
        { serviceName: 'config' },
      )
      .then((res) => res.data),
  getTripGroupings: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/trip-groupings`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  getPublicTransportEligibilityRules: (orgResourceId, params) =>
    kinetikApi
      .get(`/${orgResourceId}/config/eligibility-rule/publictransport`, {
        params,
        serviceName: 'config',
      })
      .then((res) => res.data),
  createPublicTransportEligibilityRules: (orgResourceId, rules) =>
    kinetikApi
      .post(
        `/${orgResourceId}/config/eligibility-rule/publictransport`,
        rules,
        {
          serviceName: 'config',
        },
      )
      .then((res) => res.data),
  updatePublicTransportEligibilityRules: (
    orgResourceId,
    eligibilityRuleUpdates,
  ) =>
    kinetikApi
      .patch(
        `/${orgResourceId}/config/eligibility-rule/publictransport`,
        eligibilityRuleUpdates,
        { serviceName: 'config' },
      )
      .then((res) => res.data),
  verifyPublicTransportEligibility: (orgResourceId, body) =>
    kinetikApi
      .post(
        `/${orgResourceId}/config/eligibility-rule/publictransport/verify`,
        body,
        { serviceName: 'config' },
      )
      .then((res) => res.data),
  getFeedbackPreferences: (orgID) =>
    kinetikApi
      .get(`/${orgID}/config/feedback-preferences`, { serviceName: 'config' })
      .then((res) => res.data),
  updateFeedbackPreferences: (orgID, body) =>
    kinetikApi
      .patch(`/${orgID}/config/feedback-preferences`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getUserManagedLabels: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/labels`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  createUserManagedLabel: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/labels/label`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  updateUserManagedLabel: (orgResourceId, labelUuid, body) =>
    kinetikApi
      .patch(`/${orgResourceId}/config/labels/label/${labelUuid}`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  updateLabelGroupOfUserManagedLabel: (
    orgResourceId,
    labelUuid,
    labelGroupUuid,
  ) =>
    kinetikApi
      .patch(
        `/${orgResourceId}/config/labels/label/${labelUuid}/move-to-label-group/${labelGroupUuid}`,
        {},
        {
          serviceName: 'config',
        },
      )
      .then((res) => res.data),
  deleteUserManagedLabel: (orgResourceId, labelUuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/labels/label/${labelUuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  getUserManagedLabelGroups: (orgResourceId, options) =>
    kinetikApi
      .get(`/${orgResourceId}/config/labels/label-groups`, {
        ...options,
        serviceName: 'config',
      })
      .then((res) => res.data),
  createUserManagedLabelGroup: (orgResourceId, body) =>
    kinetikApi
      .post(`/${orgResourceId}/config/labels/label-group`, body, {
        serviceName: 'config',
      })
      .then((res) => res.data),
  updateUserManagedLabelGroup: (orgResourceId, labelGroupUuid, body) =>
    kinetikApi
      .patch(
        `/${orgResourceId}/config/labels/label-group/${labelGroupUuid}`,
        body,
        {
          serviceName: 'config',
        },
      )
      .then((res) => res.data),
  deleteUserManagedLabelGroup: (orgResourceId, labelGroupUuid) =>
    kinetikApi
      .delete(`/${orgResourceId}/config/labels/label-group/${labelGroupUuid}`, {
        serviceName: 'config',
      })
      .then((res) => res.data),
};
